// EPI роут, настроен редирект
export const StubRoutes: string[] = ['postavshchikam', 'recepty'];
